import {IComponentOptions, ILogService} from "angular";
import {StateService} from "@uirouter/angularjs";
import {User} from "../../shared/model/User";
import {Application} from "../../shared/model/Application";
import {Assessment} from "../../shared/model/Assessment";
import {ChatService} from "../../shared/chat/chat.service";
import {isSystemAccepted as checkSystemAccepted} from "../../shared/model/ApplicationStatusUtil";

class AssessorController {
    public editDisabled = true; // common/application.html needs it.
    public asideContent: string;
    public firebaseDatabasePath: string;
    public currentUser: User;
    public application: Application;
    public assessments: Assessment[];

    /* @ngInject */
    constructor(private $log: ILogService,
                private base64: any,
                private $state: StateService,
                private chatService: ChatService) {
    }

    public $onInit() {
        this.$log.debug("AssessorController: application %o, assessments %o", this.application, this.assessments);

        this.$log.debug("Current user: %o", this.currentUser);
        this.checkAuthenticUser(this.currentUser);

        this.asideContent = "ASSESSMENTS";

        this.firebaseDatabasePath = `${this.chatService.APPLICATION_MESSAGES_ROOT_PATH}/${this.application.id}`;
    }

    public showAssessments() {
        this.asideContent = "ASSESSMENTS";
    }

    public showComments() {
        this.asideContent = "COMMENTS";
    }

    public isStaff() {
        return this.currentUser.isStaff;
    }

    private checkAuthenticUser(currentUser: User) {
        if (!currentUser.isStaff) {
            this.invalid();
        }
    }

    private invalid() {
        this.$state.go("invalidStatus",
            {
                message: "You do not have access to the requested assessment, " +
                "please contact faculty admin if you believe this is a mistake"
            });
    }

    /**
     * Check if the application status indicates system accepted.
     * Exposed for use in templates.
     */
    public isSystemAccepted(): boolean {
        return checkSystemAccepted(this.application.status);
    }
}

export const AssessorComponent: IComponentOptions = {
    bindings: {
        currentUser: "<",
        application: "<",
        assessments: "<",
        userCheck: "<"
    },
    controller: AssessorController,
    template: require("./assessor.html")
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/main/client/app/staff/assessor/assessor.component.ts